import { pgTable, text, timestamp, uuid, boolean } from 'drizzle-orm/pg-core';
import { defaultColumns } from './defaultColumns';
import { locationTable } from './location.sql';
import { relations } from 'drizzle-orm';
import { userTeamTable } from './userTeam.sql';
import { userTeamNotificationSettingTable } from './userTeamNotificationSetting.sql';
export const teamTable = pgTable('team', {
  id: uuid('id').primaryKey().defaultRandom(),
  name: text('name').notNull(),
  externalIdentifier: text('externalIdentifier'),
  locationId: uuid('locationId')
    .notNull()
    .references(() => locationTable.id),
  deleted: boolean('deleted').notNull().default(false),
  deletedAt: timestamp('deletedAt'),
  ...defaultColumns,
});

export const teamRelations = relations(teamTable, ({ one, many }) => ({
  userTeams: many(userTeamTable),
  location: one(locationTable, {
    fields: [teamTable.locationId],
    references: [locationTable.id],
  }),
  userTeamNotificationSettings: many(userTeamNotificationSettingTable),
}));
